var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircle = function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED1538",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M6.06 6.5a2 2 0 0 1 3.886.667c0 1.333-2 2-2 2M8 11.833h.006m6.66-3.333a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0"
  })));
};
export default SvgHelpCircle;